/**
 * Whether a signed-in person's Clerk session says they are the OWNER.
 *
 * DISPLAY ONLY. It decides whether the staff surface shows the owner's link
 * and screen; it decides nothing about access. Every owner action goes to
 * /api/admin/*, where the Worker's owner gate (workers/admin-gate.ts) checks
 * the same claim on a token it verified itself. A browser that lies here gets
 * a 403 there.
 *
 * Kept in its own React-free module so it is unit-tested without a browser.
 * Exact match, same as the Worker's parser: "Owner" is not "owner".
 */
export function isOwnerClaim(sessionClaims: unknown): boolean {
  if (sessionClaims === null || typeof sessionClaims !== 'object') return false
  return (sessionClaims as Record<string, unknown>).staffRole === 'owner'
}
